import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import './styles/index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { store } from './store';
import { Toaster } from 'react-hot-toast';

Amplify.configure(awsExports);

class TysData extends HTMLElement {
  connectedCallback() {
    document.querySelector('html').setAttribute('data-theme', localStorage.getItem('TYS-APP-THEME') || 'light')
    render(
      <React.StrictMode>
        <App store={store} />
        <Toaster />
      </React.StrictMode>,
      this
    );
  }

  disconnectedCallback() {
    unmountComponentAtNode(this);
  }
}

customElements.define('tysdata-app', TysData);